import axios from 'axios'
import { createWithEqualityFn } from 'zustand/traditional'

import { CRUDBaseStore } from './Base/CRUD'

interface ShippingAddressStore extends CRUDBaseStore {
	activate: (id: number, isActive: number) => Promise<{ success: boolean; data: any }>
}

export const API_SLUG = 'suppliers/shipping-address'

export const INITIAL_STATE = {
	id: 0,
	title: '',
	receiverFullname: '',
	receiverPhone: '',
	address: '',
	provinceId: 0,
	amphureId: 0,
	tumbonId: 0,
	isActive: true,
	latitude: 13.7563,
	longitude: 100.5018,
	buyerId: 0,
}

export const useShippingAddressStore = createWithEqualityFn<ShippingAddressStore>(
	set => ({
		data: [],
		selected: INITIAL_STATE,
		loading: false,
		setLoading: (loading: boolean) => set({ loading }),
		setError: (error: any) => set({ error }),
		setSelected: (selected: any) => set({ selected }),
		getAll: async () => {
			set({ loading: true })

			return axios
				.get(`/${API_SLUG}`)
				.then(res => {
					set({ loading: false })
					set({ data: res.data })
					return { success: true, data: res.data }
				})
				.catch(err => {
					set({ loading: false })
					set({ error: err?.response?.data?.message })
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		create: async data => {
			set({ loading: true })
			const formData = new FormData()
			Object.keys(data).forEach(key => {
				if (data[key] !== undefined) {
					formData.append(key, data[key])
				}
			})

			return axios
				.post(`/${API_SLUG}`, formData)
				.then(res => {
					set({ loading: false })
					return { success: true, data: res.data }
				})
				.catch(err => {
					set({ loading: false })
					set({ error: err?.response?.data?.message?.toString() })
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		edit: async (id, data) => {
			set({ loading: true })
			const formData = new FormData()
			Object.keys(data).forEach(key => {
				if (data[key] !== undefined) {
					formData.append(key, data[key])
				}
			})

			return axios
				.patch(`/${API_SLUG}/${id}`, formData)
				.then(res => {
					set({ loading: false })
					return { success: true, data: res.data }
				})
				.catch(err => {
					set({ loading: false })
					set({ error: err?.response?.data?.message?.toString() })
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		delete: async id => {
			set({ loading: true })

			return axios
				.delete(`/${API_SLUG}/${id}`)
				.then(res => {
					set({ loading: false })
					return { success: true, data: res.data }
				})
				.catch(err => {
					set({ loading: false })
					set({ error: err?.response?.data?.message?.toString() })
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		activate: async (id, isActive) => {
			set({ loading: true })

			return axios
				.patch(`/${API_SLUG}/${id}/activate`, { isActive })
				.then(res => {
					set({ loading: false })
					return { success: true, data: res.data }
				})
				.catch(err => {
					set({ loading: false })
					set({ error: err?.response?.data?.message?.toString() })
					return { success: false, data: err?.response?.data?.message?.toString() }
				})
		},
		clearState: () => {
			set({ data: [] })
			set({ selected: INITIAL_STATE })
			set({ loading: false })
			set({ error: null })
		},
	}),
	Object.is
)
